import { render, staticRenderFns } from "./SaleBonusModal.vue?vue&type=template&id=1e8f2f97&scoped=true"
import script from "./SaleBonusModal.vue?vue&type=script&lang=js"
export * from "./SaleBonusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8f2f97",
  null
  
)

export default component.exports